<template>
  <v-container fluid ma-0 pa-0>
    <div class="d-flex justify-space-between align-center">
      <div class="header_title">
        <v-row no-gutters class="ma-3 header_title"> Qode App Users</v-row>
      </div>
      <div>
        <v-btn
            class="white--text blue-color ml-1"
            color="darken-1"
            height="40"
            @click="addUser"
        >
          <SvgIcon text="Add User">
            <template #icon>
              <AddIcon/>
            </template>
          </SvgIcon>
        </v-btn>
      </div>
    </div>
    <div class="md-card md-theme-default fullwidth">
      <div class="md-card-content">
        <h3 class="m-b-4">Users</h3>
        <div
            class="md-content md-table md-theme-default table_borders"
            table-header-color="orange"
            value
        >
          <div
              class="md-content md-table-content md-scrollbar md-theme-default"
          >
            <table class="table border-collapse ">
              <thead class="">
              <tr class="opacity-70 tr-rounded tr-neon">
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Name</div>
                    <div class="search_column">
                      <v-autocomplete
                          solo
                          filled
                          label="Name"
                          v-model="searchParams.name"
                          item-value="name"
                          item-text="name"
                          :items="names"
                          :loading="isLoading"
                          :search-input.sync="name"
                          @change="getFilterData"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Username</div>
                    <div class="search_column">
                      <v-autocomplete
                          solo
                          filled
                          label="Username"
                          v-model="searchParams.username"
                          item-value="username"
                          item-text="username"
                          :items="usernames"
                          :loading="isLoading"
                          :search-input.sync="username"
                          @change="getFilterData"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">email</div>
                    <div class="search_column">
                      <v-autocomplete
                          solo
                          filled
                          label="Email"
                          v-model="searchParams.email"
                          item-value="email"
                          item-text="email"
                          :items="emails"
                          :loading="isLoading"
                          :search-input.sync="email"
                          @change="getFilterData"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Profession</div>
                    <div class="search_column">
                      <v-autocomplete
                          solo
                          filled
                          label="Profession"
                          v-model="searchParams.profession"
                          item-value="profession"
                          item-text="profession"
                          :items="professions"
                          :loading="isLoading"
                          :search-input.sync="profession"
                          @change="getFilterData"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>
                <th class="md-table-head" style="position: relative">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Company Name</div>
                    <div class="search_column">
                      <v-autocomplete
                          solo
                          filled
                          label="Company Name"
                          v-model="searchParams.company_name"
                          item-value="company_name"
                          item-text="company_name"
                          :items="company_names"
                          :loading="isLoading"
                          :search-input.sync="company_name"
                          @change="getFilterData"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>

                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Gender</div>
                    <div class="search_column">
                      <v-autocomplete
                          v-model="searchParams.gender"
                          solo
                          filled
                          label="Gender"
                          :items="['All', 'Male', 'Female']"
                          @change="search"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>

                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Mobile</div>
                    <div class="search_column">
                      <v-autocomplete
                          solo
                          filled
                          label="Mobile"
                          v-model="searchParams.mobile"
                          item-value="mobile"
                          item-text="mobile"
                          :items="phones"
                          :loading="isLoading"
                          :search-input.sync="phone"
                          @change="getFilterData"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Country</div>
                    <div class="search_column">
                      <v-autocomplete
                          solo
                          filled
                          label="Country"
                          v-model="searchParams.nationality"
                          item-value="id"
                          item-text="name"
                          :items="['All', ...countries]"
                          @change="getFilterData"
                      ></v-autocomplete>
                    </div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Verify</div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Action</div>
                  </div>
                </th>
              </tr>
              </thead>

              <tbody>
              <tr
                  class="md-table-row"
                  v-for="(data, index) in searchDatas"
                  :key="data.id"
              >
                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    <span  class="text_ellipse text-neon text-base pointer font-bold text-underline"  @click=" $router.push({
                            name: 'ViewUser',
                            params: { userId: data.id },
                          })">{{ data.name }} </span>

                  </div>
                </td>
                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    {{ data.username }}
                  </div>
                </td>
                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    {{ data.email }}
                  </div>
                </td>
                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    {{ data.profession ? data.profession : "NA" }}
                  </div>
                </td>
                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    {{ data.company_name ? data.company_name : "NA" }}
                  </div>
                </td>

                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    {{ data.gender || "--" }}
                  </div>
                </td>

                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    {{ data.mobile || "--" }}
                  </div>
                </td>
                <td class="md-table-cell">
                  <div class="md-table-cell-container">
                    {{ data.country_name || "--" }}
                  </div>
                </td>
                <td class="md-table-cell" style="text-align: center">
                  <template>
                    <v-icon
                        @click="changeVerifyStatus(data.id, index)"
                        :color="data.is_verified == 1 ? '#4FAEAF' : '#D3D3D3'"
                    >mdi-lightning-bolt-circle
                    </v-icon
                    >
                  </template>
                </td>
                <td class="md-table-cell" style="min-width: 120px; text-align: center">
                  <v-menu
                      v-if="data.id"
                      content-class="q-menu"
                      offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          :ripple="false"
                          class="text_capitalize"
                          elevation="0"
                          text
                          v-bind="attrs"
                          v-on="on"
                      >
                        <DotsIcon/>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item class="my-1" @click="changeUserStatus(data.id, index)">
                        <SvgIcon :text="(data.status_id === 1 ? 'Deactivate' : 'Activate')+' User'"
                                 class="font-medium text-sm gap-x-2">
                          <template #icon>
                            <ActivateIcon v-if="data.status_id !== 1"/>
                            <DeactivateIcon v-else/>
                          </template>
                        </SvgIcon>
                      </v-list-item>
                      <v-list-item class="my-1" @click="forceLogout(data.id)">
                        <SvgIcon text="Force Logout" class="font-medium text-sm gap-x-2">
                          <template #icon>
                            <LogoutIcon />
                          </template>
                        </SvgIcon>
                      </v-list-item>
                      <v-divider/>
                      <v-list-item class="my-1" @click="deleteUserConfirmation(data.id)">
                        <SvgIcon text="Delete User" class="font-medium text-sm gap-x-2"
                                 :class="{'red--text svg-stroke-red':data.status_id === 1}"
                        >
                          <template #icon>
                            <DeleteIcon />
                          </template>
                        </SvgIcon>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col cols="4">
        <v-pagination v-model="page" :length="totalPages" class="new-pagination" total-visible="7"></v-pagination>
      </v-col>
      <v-col class="d-flex align-center justify-end" cols="4">
        <div class="d-flex align-center justify-end text-sm gap-x-2">
                <span class="">
                  Result
                </span>
          <div style="width: 80px">


            <v-select
                v-model="perPage"
                :items="[10, 15, 25, 50]"
                :menu-props="{ bottom: true, offsetY: true }"
                class="q-autocomplete text-sm"
                flat
                hide-details
                solo
                dense
                @change="search"
            ></v-select>
          </div>
          <span>Per Page</span>
        </div>
      </v-col>
    </v-row>

    <user-model
        v-bind="userModel"
        @close="userModel.userID = null"
        @updated="search()"
    />
    <v-dialog v-model="addAdminUserDialog" scrollable width="50%">
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title class="headline"
          >{{ userForm.id != null ? "Update" : "Add" }} Admin
            User
          </v-card-title
          >
          <v-card-text class="form_bg">
            <v-container>
              <v-row no-gutters justify="center">
                <v-col md="4">
                  <image-upload
                      :image_path="userForm.image_path"
                      default_image="default"
                      @upload="
                      (imagedata) => {
                        userForm.profile_image = imagedata;
                      }
                    "
                      :height="300"
                  ></image-upload>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="userForm.name"
                      outlined
                      background-color="#fff"
                      label="Name*"
                      required
                      :rules="[(v) => !!v || 'Name is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="userForm.email"
                      outlined
                      background-color="#fff"
                      label="Email*"
                      required
                      :rules="[
                      (v) => !!v || 'E-mail is required',
                      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <mobile-field
                      v-model="userForm.mobile"
                      label="Phone*"
                      outlined
                      background-color="#fff"
                      required
                  ></mobile-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="userForm.username"
                      outlined
                      background-color="#fff"
                      label="Username*"
                      autocomplete="off"
                      :name="`username_${Math.random()}`"
                      required
                      :rules="[(v) => !!v || 'Username is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                      :type="userForm.hidePassword1 ? 'text' : 'password'"
                      :append-icon="
                      userForm.hidePassword1 ? 'mdi-eye' : 'mdi-eye-off'
                    "
                      label="Password*"
                      outlined
                      background-color="#fff"
                      v-model="userForm.password"
                      @click:append="
                      userForm.hidePassword1 = !userForm.hidePassword1
                    "
                      required
                      autocomplete="new-password"
                      :name="`password_${Math.random()}`"
                      :rules="[(v) => !!v || 'Password is required']"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      :type="userForm.hidePassword2 ? 'text' : 'password'"
                      :append-icon="
                      userForm.hidePassword2 ? 'mdi-eye' : 'mdi-eye-off'
                    "
                      label="Confirm password*"
                      outlined
                      background-color="#fff"
                      :autocomplete="
                      `user-password-confirm-${parseInt(userForm.name)}`
                    "
                      v-model="userForm.password_confirm"
                      @click:append="
                      userForm.hidePassword2 = !userForm.hidePassword2
                    "
                      validate-on-blur
                      required
                      :rules="[
                      (v) => !!v || 'Password is required',
                      (v) =>
                        v == this.userForm.password ||
                        'Password does not match',
                    ]"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                class="ma-2 white--text green-color"
                @click="cancelAdminUserCreate"
            >Cancel
            </v-btn
            >

            <v-btn
                class="ma-2 white--text blue-color"
                @click="addOrEditAdminUser"
            >{{ userForm.id != null ? "Update" : "Save" }}
            </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <confirm-model
        v-bind="confirmModel"
        @confirm="confirmActions"
        @close="confirmModel.id = null"
    ></confirm-model>
  </v-container>
</template>
<script>
import UserModel from "./User/UserModel";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import AddIcon from "@/assets/images/misc/plus-icon.svg";
import LogoutIcon from "@/assets/images/misc/logout.svg";
import DotsIcon from "@/assets/images/misc/h-options.svg";
import DeactivateIcon from "@/assets/images/misc/deactivate.svg";
import ActivateIcon from "@/assets/images/misc/activate.svg";
import DeleteIcon from "@/assets/images/misc/delete.svg";

export default {
  components: {
    UserModel,
    AddIcon,
    DotsIcon,
    SvgIcon,
    DeleteIcon,
    LogoutIcon,
    ActivateIcon,
    DeactivateIcon,
  },
  data() {
    return {
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      addAdminUserDialog: false,
      users: [],
      show2: false,
      valid: true,
      userForm: {},
      currentPage: 0,
      pageSize: 10,
      names: [],
      usernames: [],
      username: null,
      name: null,
      nationality: null,
      phones: [],
      phone: null,
      emails: [],
      email: null,
      profession: null,
      professions: [],
      company_names: [],
      company_name: null,
      isLoading: false,
      searchDatas: [],
      searchFlag: false,
      searchParams: {},
      AgeRange: ["All", "18-25", "26-30", "31-35"],
      Age: [],
      toAge: null,
      fromAge: null,
      page: 1,
      perPage: 10,
      totalPages: 1,
      fieldData: {
        Name: "name",
        Mobile: "mobile",
        Email: "email",
        Age: "age",
        Gender: "gender",
        Nationality: "nationality",
      },
      userModel: {userID: null, type: "details"},
    };
  },
  mounted() {
    if (this.$store.getters.getCountries.status == false) {
      this.$store.dispatch("loadCountries");
    }
    // this.$store.dispatch("loadUsers");
    this.search();
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries.data;
    },
  },
  watch: {
    page() {
      this.search();
    },
    name(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("name", val);
    },
    phone(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("mobile", val);
    },
    username(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("username", val);
    },
    email(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("email", val);
    },
    company_name(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("company_name", val);
    },
    profession(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("profession", val);
    },
    nationality(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("nationality", val);
    },
  },
  methods: {
    filterSearch(type, val) {
      if (val == "All") return;
      this.isLoading = true;
      this.$http
          .get("users/filters?field=" + type + "&search=" + val)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.isLoading = false;
              if (type == "name") {
                this.names = response.data.data;
                this.names.unshift(val);
                this.names.unshift("All");
              } else if (type == "mobile") {
                this.phones = response.data.data;
                this.phones.unshift(val);
                this.phones.unshift("All");
              } else if (type == "username") {
                this.usernames = response.data.data;
                this.usernames.unshift(val);
                this.usernames.unshift("All");
              } else if (type == "email") {
                this.emails = response.data.data;
                this.emails.unshift(val);
                this.emails.unshift("All");
              } else if (type == "company_name") {
                this.company_names = response.data.data;
                this.company_names.unshift(val);
                this.company_names.unshift("All");
              } else if (type == "profession") {
                this.professions = response.data.data;
                this.professions.unshift(val);
                this.professions.unshift("All");
              } else if (type == "nationality") {
                this.countries = response.data.data;
                this.countries.unshift(val);
                this.countries.unshift("All");
              }
            }
          })

          .catch((error) => {
            this.errorChecker(error);
          });
    },
    getFilterData() {
      this.page = 1;
      this.search();
    },
    ageOkClick() {
      if (this.fromAge != null && this.toAge != null) {
        this.searchParams.from_age = this.fromAge;
        this.searchParams.to_age = this.toAge;
        let customAgeRange = this.fromAge + "-" + this.toAge;
        this.AgeRange.push(customAgeRange);
        this.searchParams.age = customAgeRange;
        this.toAge = null;
        this.fromAge = null;
        this.$refs.ageRef.blur();
        this.search();
      }
    },
    ageChange() {
      if (this.searchParams.age != "All") {
        let data = this.searchParams.age.split("-");
        this.searchParams.from_age = data[0];
        this.searchParams.to_age = data[1];
        this.search();
      } else {
        this.allAge();
      }
    },
    allAge() {
      delete this.searchParams.from_age;
      delete this.searchParams.to_age;
      delete this.searchParams.age;
      this.search();
    },
    showUserModel(userId) {
      this.userModel.userID = parseInt(userId);
      this.userModel.type = "details";
    },
    search() {
      let url = "";
      if (this.searchParams.name == "All") {
        this.searchParams.name = null;
      } else if (typeof this.searchParams.name != "undefined") {
        url += "&name=" + this.searchParams.name;
      }
      if (this.searchParams.email == "All") {
        delete this.searchParams.email;
      } else if (typeof this.searchParams.email != "undefined") {
        url += "&email=" + this.searchParams.email;
      }
      if (this.searchParams.username == "All") {
        delete this.searchParams.username;
      } else if (typeof this.searchParams.username != "undefined") {
        url += "&username=" + this.searchParams.username;
      }
      if (this.searchParams.mobile == "All") {
        delete this.searchParams.mobile;
      } else if (typeof this.searchParams.mobile != "undefined") {
        url += "&mobile=" + this.searchParams.mobile;
      }
      if (this.searchParams.gender == "All") {
        delete this.searchParams.gender;
      } else if (typeof this.searchParams.gender != "undefined") {
        url += "&gender=" + this.searchParams.gender;
      }
      if (this.searchParams.company_name == "All") {
        this.searchParams.company_name = null;
      } else if (typeof this.searchParams.company_name != "undefined") {
        url += "&company_name=" + this.searchParams.company_name;
      }
      if (this.searchParams.profession == "All") {
        this.searchParams.profession = null;
      } else if (typeof this.searchParams.profession != "undefined") {
        url += "&profession=" + this.searchParams.profession;
      }
      if (this.searchParams.nationality == "All") {
        delete this.searchParams.nationality;
      } else if (typeof this.searchParams.nationality != "undefined") {
        url += "&nationality=" + this.searchParams.nationality;
      }
      if (
          typeof this.searchParams.from_age != "undefined" &&
          typeof this.searchParams.to_age != "undefined"
      ) {
        url +=
            "&from_age=" +
            this.searchParams.from_age +
            "&to_age=" +
            this.searchParams.to_age;
      }
      this.showLoader("Loading Users");
      this.$http
          .get(
              "users/list?page=" +
              this.page +
              "&per_page=" +
              (this.perPage != null ? this.perPage : 10) +
              url
          )
          .then((response) => {
            this.hideLoader();
            if (response.status == 200 && response.data.status) {
              this.searchDatas = response.data.data;
              this.totalPages = response.data.total_pages;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },

    checkMobileExist() {
      if (this.loading) return;
      this.showLoader("Checking");
      this.loading = true;
      this.$http
          .get(`users?mobile=${this.userForm.mobile}`)
          .then((response) => {
            if (response.status == 200) {
              // this.isSearchLoading = false;
              this.hideLoader();
              this.loading = false;
              let data = response.data.data;
              if (data.length > 0) {
                this.userForm.mobile = null;
                this.showError("Customer exist with same mobile number");
                return false;
              } else {
                return true;
              }
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    ok(id, index) {
      this.$http
          .put(`users/${id}/status`)
          .then((response) => {
            if (response.status == 200) {
              let status = response.data.data.status_id;
              this.users[index].status_id = status;
              this.showSuccess(
                  `User ${status == 1 ? "activated" : "deactivated"} successfully`
              );
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    changeUserStatus(id, index) {
      this.$http
          .put(`users/toggle-status/${id}`)
          .then((response) => {
            if (response.status == 200) {
              let status = response.data.data.status_id;
              this.searchDatas[index].status_id = status;
              this.showSuccess(
                  `User ${status == 1 ? "activated" : "deactivated"} successfully`
              );
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    changeVerifyStatus(id, index) {
      this.$http
          .put(`users/toggle-verify-status/${id}`)
          .then((response) => {
            if (response.status == 200) {
              let is_verified = response.data.data.is_verified;
              this.searchDatas[index].is_verified = is_verified;
              this.showSuccess(
                  `User ${
                      is_verified == 1 ? "verified" : "unverified"
                  } successfully`
              );
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    confirmActions(data) {
      this.deleteUser(data.id);
      this.$forceUpdate();
      this.confirmModel.id = null;
    },
    forceLogout(id) {
      this.showLoader("Checking");
      let formData = new FormData();
      formData.set("user_id", id);
      this.$http({
        url: "users/admin/force-logout",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data;",
        },
      })
          .then((response) => {
            if (response.status == 200) {
              this.hideLoader();
              // let status = response.data.data.status_id;
              this.showSuccess(`User account logout successfully`);
            }
          })
          .catch((error) => {
            this.hideLoader();
            this.errorChecker(error);
          });
    },
    deleteUserConfirmation(id) {
      let msg =
          "This will Delete the User Status. By clicking Yes you can confirm the operation.";
      this.confirmModel = {
        id: id,
        title: `Do you want to delete the User?`,
        description: msg,
      };
    },
    deleteUser(id) {
      this.showLoader("Checking");
      let formData = new FormData();
      formData.set("user_id", id);
      this.$http({
        url: "admin/delete-user",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data;",
        },
      })
          .then((response) => {
            if (response.status == 200) {
              this.hideLoader();
              // let status = response.data.data.status_id;
              this.showSuccess(`User account deleted successfully`);
              this.search();
            }
          })
          .catch((error) => {
            this.hideLoader();
            this.errorChecker(error);
          });
    },

    cancelAdminUserCreate() {
      this.$refs.form.resetValidation();
      this.UserForm = {};
      this.addAdminUserDialog = false;
    },
    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },
    addOrEditAdminUser() {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      let formData = new FormData();
      formData.set("name", this.userForm.name);
      if (this.userForm.password != null) {
        formData.set("password", this.userForm.password);
      }
      if (this.userForm.email != null) {
        formData.set("email", this.userForm.email);
      }
      if (this.userForm.profile_image) {
        formData.set("profile_image", this.userForm.profile_image);
      }
      formData.set("mobile", this.userForm.mobile);
      formData.set("username", this.userForm.username);
      this.$http({
        url:
            "users/register-admin" +
            (this.userForm.id ? `/${this.userForm.id}` : ""),
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
          .then((response) => {
            if (response.status == 200) {
              this.addAdminUserDialog = false;
              this.showSuccess("Admin User Added Successfully.");
              this.search();
              //  this.$store.dispatch("loadUsers");
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    addUser() {
      this.userForm = {};
      this.subModules = [];
      this.addAdminUserDialog = true;
      setTimeout(() => {
        this.onResize();
      }, 10);
    },
  },
};
</script>
<style scoped>

.validation-message {
  color: red;
  font-size: 12px;
}

.md-card {
  margin: 0 0 25px 0;
}

.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
</style>
